export const shouldShowConsent = (consentPermissions, shouldShowBlocksLegacyConsent) => consentPermissions.length > 0 || shouldShowBlocksLegacyConsent;
//# sourceMappingURL=shouldShowConsent.js.map